import { Component, Input } from "@angular/core";

@Component({
  selector: "app-artifacts-hash-tooltip",
  templateUrl: "./artifacts-hash-tooltip.component.html",
  styleUrls: ["./artifacts-hash-tooltip.component.scss"],
  standalone: true,
})
export class ArtifactsHashTooltipComponent {
  @Input() data?: string | null;
}
